import { Button } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setMenuTitle,
  setShowMenu,
  setTotalQuestions,
} from "../../redux/slices/common_slice";

const CommonStepper = () => {
  const stepperStatus = useSelector((state) => state.common?.stepperStatus);
  const [step, setStep] = useState("1");
  const totalQuestions = useSelector((state) => state.common.totalQuestions);
  const answeredQuestions = useSelector(
    (state) => state.common?.answeredQuestions
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isResolutionBetween425And768, setIsResolutionBetween425And768] =
    useState(false);
  const [isLargerDeviceResolution, setIsLargerDeviceResolution] =
    useState(false);
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsResolutionBetween425And768(width >= 450 && width <= 768);
      setIsLargerDeviceResolution(width >= 1200 && width <= 1400);
    };

    // Initial check on component mount
    handleResize();

    // Event listener for window resize
    window.addEventListener("resize", handleResize);

    // Clean up event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getStepStatus();
  }, [stepperStatus]);
  const getStepStatus = () => {
    if (stepperStatus?.isExpenseCompleted) {
      setStep("4");
    } else if (
      stepperStatus?.isIncomeCompleted &&
      window.location.href.includes("create-profile/expenses")
    ) {
      setStep("3");
    } else if (
      stepperStatus?.isProfileCompleted &&
      window.location.href.includes("create-profile/income")
    ) {
      setStep("2");
    } else if (window.location.href.includes("create-profile/about-you")) {
      setStep("1");
      if (!totalQuestions) {
        dispatch(setTotalQuestions(7));
      }
    }
  };
  const getDynamicHeight = () => {
    const num = isLargerDeviceResolution ? 34 : 58;
    const percentage = (answeredQuestions / totalQuestions) * 100;
    const dynamicHeight = Math.min((percentage / 100) * num, num);
    return {
      height: `${dynamicHeight}px`,
    };
  };
  const getDynamicWidth = () => {
    const percentage = (answeredQuestions / totalQuestions) * 100;
    const dynamicWidth = Math.min((percentage / 100) * 50, 50);
    return {
      width:
        window.innerWidth < 360
          ? "38.2381%"
          : window.innerWidth <= 375 && window.innerWidth >= 360
          ? "37.75%"
          : isResolutionBetween425And768
          ? "69%"
          : `${dynamicWidth}%`,
    };
  };
  return (
    <div className="stepper-card-main">
      <div className="row logo-row">
        <div className="col-12 position-relative">
          <img
            src="/assets/images/butterfly-logo.svg"
            alt=""
            className="img-fluid main-log-img"
          />
          <img
            src="/assets/images/icons/logo-favicon.svg"
            alt=""
            className="img-fluid mobile-logo-favicon"
          />
          <Button
            className="setting-btn mobile-setting-btn"
            onClick={() => {
              navigate("/settings");
              dispatch(setShowMenu(true));
              dispatch(setMenuTitle(t("settings.title")));
            }}
          >
            <img
              src="/assets/images/icons/hamburger-menu-icon.svg"
              alt=""
              className="img-fluid"
            />
          </Button>
          <p>{t("commonStepper.title")}</p>
        </div>
      </div>
      <div className="row stepper-row-inner">
        <div className="col-12">
          <div className="custom-steps">
            <div
              className={`custom-steps-item ${
                step === "1"
                  ? "custom-steps-item-process"
                  : step < "1"
                  ? "custom-steps-item-wait"
                  : "custom-steps-item-finish"
              }`}
            >
              {step == 1 && (
                <div
                  className="progress-fill-mobile"
                  style={getDynamicWidth()}
                ></div>
              )}
              <div className="custom-steps-container">
                {step == 1 && (
                  <div
                    className="progress-fill"
                    style={getDynamicHeight()}
                  ></div>
                )}
                <div className="custom-steps-icon">
                  <div className="custom-steps-icon-inner">
                    <img
                      src="/assets/images/icons/about-icon-white.svg"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                </div>
                <div className="custom-steps-content">
                  <div className="custom-steps-title">
                    {t("commonStepper.section1")}
                  </div>
                  <div className="custom-details-title">
                    <h6 className="mb-0">
                      {t("commonStepper.section1Step")}{" "}
                      <span>{t("commonStepper.section1")}</span>
                    </h6>
                    <h6 className="mb-0">
                      <span>
                        {answeredQuestions} {t("commonStepper.of")}{" "}
                        {totalQuestions}
                      </span>{" "}
                      {t("commonStepper.questionAns")}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="custom-steps">
            <div
              className={`custom-steps-item ${
                step === "2"
                  ? "custom-steps-item-process"
                  : step < "2"
                  ? "custom-steps-item-wait"
                  : "custom-steps-item-finish"
              }`}
            >
              {step == 2 && (
                <div
                  className="progress-fill-mobile"
                  style={getDynamicWidth()}
                ></div>
              )}
              <div className="custom-steps-container">
                {step == 2 && (
                  <div
                    className="progress-fill"
                    style={getDynamicHeight()}
                  ></div>
                )}
                <div className="custom-steps-icon">
                  <div className="custom-steps-icon-inner">
                    <img
                      src="/assets/images/icons/income-icon-white.svg"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                </div>
                <div className="custom-steps-content">
                  <div className="custom-steps-title">
                    {t("commonStepper.section2")}
                  </div>
                  <div className="custom-details-title">
                    <h6 className="mb-0">
                      {t("commonStepper.section2Step")}{" "}
                      <span>{t("commonStepper.section2")}</span>
                    </h6>
                    <h6 className="mb-0">
                      <span>
                        {answeredQuestions} {t("commonStepper.of")}{" "}
                        {totalQuestions}
                      </span>{" "}
                      {t("commonStepper.questionAns")}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="custom-steps">
            <div
              className={`custom-steps-item ${
                step === "3"
                  ? "custom-steps-item-process"
                  : step < "3"
                  ? "custom-steps-item-wait"
                  : "custom-steps-item-finish"
              }`}
            >
              {step == 3 && (
                <div
                  className="progress-fill-mobile"
                  style={getDynamicWidth()}
                ></div>
              )}
              <div className="custom-steps-container">
                {step == 3 && (
                  <div
                    className="progress-fill"
                    style={getDynamicHeight()}
                  ></div>
                )}
                <div className="custom-steps-icon">
                  <div className="custom-steps-icon-inner">
                    <img
                      src="/assets/images/icons/expenses-icon-white.svg"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                </div>
                <div className="custom-steps-content">
                  <div className="custom-steps-title">
                    {t("commonStepper.section3")}
                  </div>
                  <div className="custom-details-title">
                    <h6 className="mb-0">
                      {t("commonStepper.section3Step")}{" "}
                      <span>{t("commonStepper.section3")}</span>
                    </h6>
                    <h6 className="mb-0">
                      <span>
                        {answeredQuestions} {t("commonStepper.of")}{" "}
                        {totalQuestions}
                      </span>{" "}
                      {t("commonStepper.questionAns")}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="custom-steps final-step">
            <div
              className={`custom-steps-item ${
                step === "4"
                  ? "custom-steps-item-process"
                  : step < "4"
                  ? "custom-steps-item-wait"
                  : "custom-steps-item-finish"
              }`}
            >
              <div className="custom-steps-container">
                <div className="custom-steps-icon">
                  <div className="custom-steps-icon-inner">
                    <img
                      src="/assets/images/icons/report-icon-white.svg"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                </div>
                <div className="custom-steps-content">
                  <div className="custom-steps-title">
                    {t("commonStepper.section4")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonStepper;
